import React, { memo } from "react";
import {  useSelector } from "react-redux";
import { get } from "lodash";
import CustomOffCanvasThree from '../CustomOffCanvasThree.jsx';
import "./features.common.styles.scss";
import PropTypes from "prop-types";

const EmptyDrillDownThree = ({ subHeading }) => {
    const commonSliceState = useSelector((state) => state.common);
    const offcanvasThreeState = useSelector((state) => state.common?.offcanvasThreeState);
    const selectedData = get(commonSliceState, "offcanvasThreeState.selectedData", []);
    return (
        <CustomOffCanvasThree className="custom-off-canvas drilldownThree padding25">
            <div className={`meantimewrap custom_scroll ${offcanvasThreeState?.customClass}`}>
                <h3 className="flowhead">
                    {offcanvasThreeState?.title}
                    {subHeading && <span>{subHeading} </span>}
                </h3>
                {selectedData ? (
                    selectedData
                ) : (
                    <>
                    </>)
                }
            </div>
        </CustomOffCanvasThree>

        
    );
};
EmptyDrillDownThree.propTypes = {
    subHeading: PropTypes.string,
  };
export default memo(EmptyDrillDownThree);


